<template>
	<dv-border-box-10>
		<div class="marquee">
			<div class="marquee_header">
				<div class="title">标志</div>
				<div class="title">标志名称</div>
				<div class="title">所在地</div>
				<div class="title">在用企业</div>
			</div>
			<div class="marquee_center">
				<vue-seamless-scroll :data="rollList" :class-option="defaultOption">
					<ul class="marqueeList">
						<li class="marqueeItem" v-for="(item, index) in rollList" :key="index" @click="toDetail(item)">
							<div class="marqueeItem_img">
								<img :src="item.IMGURL" alt="">
							</div>
							<div class="marqueeItem_name">{{item.NAME}}</div>
							<div class="marqueeItem_text">{{item.LOCATION}}</div>
							<div class="marqueeItem_text">{{item.USENUMBER ? item.USENUMBER : 0}}</div>
						</li>
					</ul>
				</vue-seamless-scroll>
			</div>
		</div>
	</dv-border-box-10>
</template>

<script>
	import data from '@/assets/landmark/sign2'
	export default {
		data() {
			return {
				rollList: []
			}
		},
		computed: {
			defaultOption() {
				return {
					step: 0.8, // 数值越大速度滚动越快
					limitMoveNum:10, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight:80, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime:3000 // 单步运动停止的时间(默认值1000ms)
				}
			}
		},
		mounted() {
			this.rollList = data
		},
		methods: {
			toDetail(item){
				this.$emit('toSignDetail',item)
			},
		},
	}
</script>

<style scoped lang="scss">
</style>
